import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1uhekn9-0"
})(["min-height:360px;padding:12px 24px 36px;"]);